import Select from '@blocks/Select'
import React, { useRef } from 'react'

export default function SalonSort({ archive }: Props) {
    const sort = useRef<ReturnType<ArchiveHookSortFn<Admin.Resources.Participation>>>()

    return (
        <Select 
            id="sort" 
            name="sort"
            label="Sort"
            background="#fff"
            height="s"
            isClearable
            options={[
                { label: `Highest Score`, value: "score:reversed" },
                { label: `Lowest Score`, value: "score" },
                { label: `Awards`, value: "awards" }
            ]} 
            onChange={
                (option: Interfaces.Options<"awards" | "score" | "score:reversed">[0]) => {
                    if (!option?.value) {
                        sort.current?.reset()
                        return
                    }

                    switch (option.value) {
                        case 'score':
                            sort.current = archive.sort(sortByScore)
                            break
                        case 'score:reversed':
                            sort.current = archive.sort(sortByScore, true)
                            break
                        case 'awards':
                            sort.current = archive.sort(sortByAwards)
                            break
                    }
                    
                    sort.current.set()
                }
            } 
        />
    )
}

const sortByScore: CompareFunction<Admin.Resources.Participation> = (a, b) => {
    const voteA = a.votes_sum_score || 0
    const voteB = b.votes_sum_score || 0
    return voteA - voteB
}

const sortByAwards: CompareFunction<Admin.Resources.Participation> = (a, b) => {
    const priorityA = a.award?.priority || 999
    const priorityB = b.award?.priority || 999
    return priorityA - priorityB
}

interface Props {
    archive: ArchiveHookResponse<Admin.Resources.Participation>
}